import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/close.svg'
import _imports_1 from '@/assets/icon/calendar.svg'


const _withScopeId = n => (_pushScopeId("data-v-6e824df1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component popup" }
const _hoisted_2 = { class: "popup_box contents__box" }
const _hoisted_3 = { class: "title_box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "PACS", -1))
const _hoisted_5 = { class: "search_filter_box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.9989 15.5C11.0706 15.5 10.1804 15.1313 9.52399 14.4749C8.86761 13.8185 8.49886 12.9283 8.49886 12C8.49886 11.0717 8.86761 10.1815 9.52399 9.52513C10.1804 8.86875 11.0706 8.5 11.9989 8.5C12.9271 8.5 13.8174 8.86875 14.4737 9.52513C15.1301 10.1815 15.4989 11.0717 15.4989 12C15.4989 12.9283 15.1301 13.8185 14.4737 14.4749C13.8174 15.1313 12.9271 15.5 11.9989 15.5ZM19.4289 12.97C19.4689 12.65 19.4989 12.33 19.4989 12C19.4989 11.67 19.4689 11.34 19.4289 11L21.5389 9.37C21.7289 9.22 21.7789 8.95 21.6589 8.73L19.6589 5.27C19.5389 5.05 19.2689 4.96 19.0489 5.05L16.5589 6.05C16.0389 5.66 15.4989 5.32 14.8689 5.07L14.4989 2.42C14.4589 2.18 14.2489 2 13.9989 2H9.99886C9.74886 2 9.53886 2.18 9.49886 2.42L9.12886 5.07C8.49886 5.32 7.95886 5.66 7.43886 6.05L4.94886 5.05C4.72886 4.96 4.45886 5.05 4.33886 5.27L2.33886 8.73C2.20886 8.95 2.26886 9.22 2.45886 9.37L4.56886 11C4.52886 11.34 4.49886 11.67 4.49886 12C4.49886 12.33 4.52886 12.65 4.56886 12.97L2.45886 14.63C2.26886 14.78 2.20886 15.05 2.33886 15.27L4.33886 18.73C4.45886 18.95 4.72886 19.03 4.94886 18.95L7.43886 17.94C7.95886 18.34 8.49886 18.68 9.12886 18.93L9.49886 21.58C9.53886 21.82 9.74886 22 9.99886 22H13.9989C14.2489 22 14.4589 21.82 14.4989 21.58L14.8689 18.93C15.4989 18.67 16.0389 18.34 16.5589 17.94L19.0489 18.95C19.2689 19.03 19.5389 18.95 19.6589 18.73L21.6589 15.27C21.7789 15.05 21.7289 14.78 21.5389 14.63L19.4289 12.97Z",
    fill: "white"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "search_option_box" }
const _hoisted_9 = { class: "search_select_box" }
const _hoisted_10 = { class: "option" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6e824df1><mask id=\"mask0_1669_79957\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" data-v-6e824df1><rect width=\"20\" height=\"20\" transform=\"matrix(1 0 0 -1 0 20)\" fill=\"#D9D9D9\" data-v-6e824df1></rect></mask><g mask=\"url(#mask0_1669_79957)\" data-v-6e824df1><path d=\"M10 7.18758L5 12.1876L6.16667 13.3542L10 9.54175L13.8333 13.3542L15 12.1876L10 7.18758Z\" fill=\"white\" data-v-6e824df1></path></g></svg>", 1)
const _hoisted_12 = { class: "flex justify-center items-center datepicker" }
const _hoisted_13 = { class: "text_box" }
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon_box" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_16 = { class: "text_box" }
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon_box" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "range_warning_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "range_warning" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 10.6221C7.22793 10.6221 6.59253 11.243 6.59961 12.0078C6.59239 12.7872 7.22785 13.4082 8 13.4082C8.73592 13.408 9.3922 12.7871 9.39941 12.0078C9.39207 11.2431 8.73584 10.6223 8 10.6221ZM6.61426 2.7998L6.87402 10.002H9.13965L9.38477 2.7998H6.61426Z",
        fill: "#888AA5"
      })
    ]),
    /*#__PURE__*/_createElementVNode("h3", null, "날짜는 최대 2주 선택 가능합니다.")
  ])
], -1))
const _hoisted_20 = {
  key: 1,
  class: "search_box"
}
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "pacs table_box" }
const _hoisted_23 = { style: {"width":"200px"} }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6e824df1><mask id=\"mask0_334_286\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-6e824df1><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-6e824df1></rect></mask><g mask=\"url(#mask0_334_286)\" data-v-6e824df1><path d=\"M6.36686 12L2.56686 8.20001L3.51686 7.25001L6.36686 10.1L12.4835 3.98334L13.4335 4.93334L6.36686 12Z\" data-v-6e824df1></path></g></svg>", 1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Patient ID", -1))
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div style=\"width:165px;\" data-v-6e824df1><h3 data-v-6e824df1>Patient Name</h3></div><div style=\"width:95px;\" data-v-6e824df1><h3 data-v-6e824df1>Study Date</h3></div><div style=\"width:70px;\" data-v-6e824df1><h3 data-v-6e824df1>Gender</h3></div><div style=\"width:110px;\" data-v-6e824df1><h3 data-v-6e824df1>Age</h3></div><div style=\"width:110px;\" data-v-6e824df1><h3 data-v-6e824df1>Modality</h3></div><div style=\"width:calc(100% - 758px);\" data-v-6e824df1><h3 data-v-6e824df1>Thumbnail</h3></div>", 6)
const _hoisted_33 = { class: "table_body my-scroll" }
const _hoisted_34 = { style: {"width":"200px"} }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6e824df1><mask id=\"mask0_334_286\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-6e824df1><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-6e824df1></rect></mask><g mask=\"url(#mask0_334_286)\" data-v-6e824df1><path d=\"M6.36686 12L2.56686 8.20001L3.51686 7.25001L6.36686 10.1L12.4835 3.98334L13.4335 4.93334L6.36686 12Z\" data-v-6e824df1></path></g></svg>", 1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "file_name_box" }
const _hoisted_39 = { class: "text-ellipsis" }
const _hoisted_40 = { style: {"width":"165px"} }
const _hoisted_41 = { class: "text-ellipsis" }
const _hoisted_42 = { style: {"width":"95px"} }
const _hoisted_43 = { class: "text-ellipsis" }
const _hoisted_44 = { style: {"width":"70px"} }
const _hoisted_45 = { class: "text-ellipsis" }
const _hoisted_46 = { style: {"width":"110px"} }
const _hoisted_47 = { class: "text-ellipsis" }
const _hoisted_48 = { style: {"width":"110px"} }
const _hoisted_49 = { class: "text-ellipsis" }
const _hoisted_50 = { style: {"width":"calc(100% - 758px)"} }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6e824df1><mask id=\"mask0_1632_102860\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" data-v-6e824df1><rect width=\"20\" height=\"20\" fill=\"#ffffff\" data-v-6e824df1></rect></mask><g mask=\"url(#mask0_1632_102860)\" data-v-6e824df1><path d=\"M16.3333 17.5L11.0833 12.25C10.6667 12.5833 10.1875 12.8472 9.64583 13.0417C9.10417 13.2361 8.52778 13.3333 7.91667 13.3333C6.40278 13.3333 5.12153 12.809 4.07292 11.7604C3.02431 10.7118 2.5 9.43056 2.5 7.91667C2.5 6.40278 3.02431 5.12153 4.07292 4.07292C5.12153 3.02431 6.40278 2.5 7.91667 2.5C9.43056 2.5 10.7118 3.02431 11.7604 4.07292C12.809 5.12153 13.3333 6.40278 13.3333 7.91667C13.3333 8.52778 13.2361 9.10417 13.0417 9.64583C12.8472 10.1875 12.5833 10.6667 12.25 11.0833L17.5 16.3333L16.3333 17.5ZM7.91667 11.6667C8.95833 11.6667 9.84375 11.3021 10.5729 10.5729C11.3021 9.84375 11.6667 8.95833 11.6667 7.91667C11.6667 6.875 11.3021 5.98958 10.5729 5.26042C9.84375 4.53125 8.95833 4.16667 7.91667 4.16667C6.875 4.16667 5.98958 4.53125 5.26042 5.26042C4.53125 5.98958 4.16667 6.875 4.16667 7.91667C4.16667 8.95833 4.53125 9.84375 5.26042 10.5729C5.98958 11.3021 6.875 11.6667 7.91667 11.6667Z\" fill=\"#ffffff\" data-v-6e824df1></path></g></svg>", 1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "no_result_box"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No PACS data available", -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "pagenation_box" }
const _hoisted_58 = {
  key: 0,
  class: "thumbnail_preview_box"
}
const _hoisted_59 = {
  key: 0,
  class: "loading_box"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-area" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" })
], -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!
  const _component_Pagenation = _resolveComponent("Pagenation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "close_icon",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePopup()))
      }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "button__gray pacs_setting_btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePacsSettingBtn && _ctx.handlePacsSettingBtn(...args)))
          }, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(["option_box", {'open': _ctx.selectBoxOpen}]),
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectBox && _ctx.toggleSelectBox(...args)))
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.selectedOption), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["option", {'active': _ctx.selectedOption == 'Study Date'}]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClickOption('Study Date')))
            }, "Study Date", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["option", {'active': _ctx.selectedOption == 'ID'}]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClickOption('ID')))
            }, "ID", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["option", {'active': _ctx.selectedOption == 'Name'}]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClickOption('Name')))
            }, "Name", 2),
            _hoisted_11
          ], 2)
        ]),
        (_ctx.selectedOption == 'Study Date')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "date_box",
              onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mouseEnter = true)),
              onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.mouseEnter = false))
            }, [
              (_openBlock(), _createBlock(_component_VDatePicker, {
                key: _ctx.calendarKey,
                modelValue: _ctx.range,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((_ctx.range) = $event)),
                  _ctx.handleSelect
                ],
                "is-range": "",
                attributes: _ctx.attributes
              }, {
                default: _withCtx(({  inputEvents }) => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _mergeProps({
                      class: ["datepicker_box", {'active': _ctx.mouseEnter}]
                    }, _toHandlers(inputEvents.start, true)), [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("input", {
                          value: _ctx.range.start ? _ctx.formatDate(_ctx.range.start) : '',
                          placeholder: "YYYY.MM.DD",
                          readonly: ""
                        }, null, 8, _hoisted_14)
                      ]),
                      _hoisted_15
                    ], 16),
                    _createElementVNode("h3", {
                      class: _normalizeClass({'active': _ctx.mouseEnter})
                    }, "~", 2),
                    _createElementVNode("div", _mergeProps({
                      class: ["datepicker_box", {'active': _ctx.mouseEnter}]
                    }, _toHandlers(inputEvents.end, true)), [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("input", {
                          value: _ctx.range.end ? _ctx.formatDate(_ctx.range.end) : '',
                          placeholder: "YYYY.MM.DD",
                          readonly: ""
                        }, null, 8, _hoisted_17)
                      ]),
                      _hoisted_18
                    ], 16)
                  ])
                ]),
                footer: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["modelValue", "attributes", "onUpdate:modelValue"]))
            ], 32))
          : _createCommentVNode("", true),
        (_ctx.selectedOption != 'Study Date')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: _ctx.placeholder,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchText) = $event)),
                spellcheck: "false",
                onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.handleSearchBtnClick()), ["enter"]))
              }, null, 40, _hoisted_21), [
                [_vModelText, _ctx.searchText]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["button__gray search_btn", {'active': _ctx.searchText.length > 0 || _ctx.selectedOption == 'Study Date'}]),
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSearchBtnClick()))
        }, "Search", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["button__gray upload_btn", {'active': _ctx.selectedCount>0}]),
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleUploadBtnClick()))
        }, "Upload", 2)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", {
          class: _normalizeClass(["table_header", {active: _ctx.checkAll}])
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: "checkbox",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectAllList(!_ctx.checkAll)))
            }, _hoisted_25),
            _hoisted_26
          ]),
          _hoisted_27
        ], 2),
        _createElementVNode("div", _hoisted_33, [
          (_ctx.pacsData.length>0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currPageData, (data) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: data.SOPInstanceUID,
                  class: _normalizeClass(["table_tr", {active: data.selected}])
                }, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", {
                      class: "checkbox",
                      onClick: ($event: any) => (_ctx.selectList(data))
                    }, _hoisted_37, 8, _hoisted_35),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("h3", _hoisted_39, _toDisplayString(data.PatientID), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("h3", _hoisted_41, _toDisplayString(data.PatientName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.formatStudyDate(data.StudyDate)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("h3", _hoisted_45, _toDisplayString(data.PatientSex), 1)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("h3", _hoisted_47, _toDisplayString(_ctx.formatPatientAge(data.PatientAge)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("h3", _hoisted_49, _toDisplayString(data.Modality), 1)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["thumbnail_box", {'active': _ctx.targetUID == data.SOPInstanceUID}]),
                      onClick: ($event: any) => (_ctx.handleThumbnailClick(data.SOPInstanceUID))
                    }, _hoisted_53, 10, _hoisted_51)
                  ])
                ], 2))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56))
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createVNode(_component_Pagenation)
      ]),
      (_ctx.showThumbnail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
              : _createCommentVNode("", true),
            _createElementVNode("img", { src: _ctx.thumbnailUrl }, null, 8, _hoisted_62)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}